import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Button,
    DoubleBanner,
    FluidImage,
    Link,
    P,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { __, __image, __url } from '@99designs/i18n';
import { sendNavigationEvent, usePage } from '@99designs/tracking';
import { CloudinaryImage } from '../CloudinaryImage';

const StyledBannerImage = styled(DoubleBanner)`
    margin: auto;
`;

const DesignServicesStyledBanner = styled(Banner)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        background-color: ${tokensRaw.SwanBaseColorWhite};
    }
`;

const CustomPackagingStyledBanner = styled(Banner)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        background-color: ${tokensRaw.SwanSemColorBrandWarmWhite};
    }
`;

export function PackagingDoubleBanner() {
    const { pageData } = usePage();
    const onClickTracking = () => {
        sendNavigationEvent({
            label: 'Content: Double Banner',
            eventDetail: '/design/packaging;/packaging;Double Banner;Packaging',
            navigationDetail: 'Packaging',
            ...pageData,
        });
    };

    const onClickDesignServicesTracking = () => {
        sendNavigationEvent({
            label: 'Content: Double Banner',
            eventDetail: '/design/packaging;/design;Double Banner;DesignHub',
            navigationDetail: 'DesignHub',
            ...pageData,
        });
    };

    return (
        <StyledBannerImage>
            <CustomPackagingStyledBanner variant="full-width-image">
                <BannerTextContainer>
                    <BannerText>
                        <BannerEyebrow>{__('Custom Packaging')}</BannerEyebrow>
                        <BannerTitle as="h2">{__('Ready to print?')}</BannerTitle>
                        <BannerDescription>
                            <P>
                                {__(
                                    'Deliver your products in style with personalized boxes, bags and more.'
                                )}
                            </P>
                        </BannerDescription>
                        <BannerLinks>
                            <Button
                                skin="primary"
                                render={(props) => (
                                    <Link
                                        onClick={onClickTracking}
                                        to={__url('/packaging')}
                                        className={props.className}
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                {__('Find out more')}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
                <BannerImageContainer>
                    <BannerImage imageFocalPoint="center top">
                        <CloudinaryImage
                            render={(props) => (
                                <FluidImage
                                    src={props.src}
                                    srcSet={props.srcSet}
                                    alt=""
                                    role="presentation"
                                />
                            )}
                            imagePath={__image(
                                'expert_services/DesignCategoryPage/Packaging/CustomPackaging'
                            )}
                        />
                    </BannerImage>
                </BannerImageContainer>
            </CustomPackagingStyledBanner>
            <DesignServicesStyledBanner variant="full-width-image">
                <BannerTextContainer>
                    <BannerText>
                        <BannerEyebrow>{__('Design Services')}</BannerEyebrow>
                        <BannerTitle as="h2">{__('More design needs?')}</BannerTitle>
                        <BannerDescription>
                            <P>
                                {__(
                                    'Work with our talented, professional designers to bring your vision to life.'
                                )}
                            </P>
                        </BannerDescription>
                        <BannerLinks>
                            <Button
                                skin="primary"
                                render={(props) => (
                                    <Link
                                        onClick={onClickDesignServicesTracking}
                                        to={__url('/design')}
                                        className={props.className}
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                {__('Visit Design Services')}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
                <BannerImageContainer>
                    <BannerImage imageFocalPoint="center top">
                        <CloudinaryImage
                            render={(props) => (
                                <FluidImage
                                    src={props.src}
                                    srcSet={props.srcSet}
                                    alt=""
                                    role="presentation"
                                />
                            )}
                            imagePath={__image(
                                'expert_services/DesignCategoryPage/Packaging/DesignServices'
                            )}
                        />
                    </BannerImage>
                </BannerImageContainer>
            </DesignServicesStyledBanner>
        </StyledBannerImage>
    );
}
